import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
 const ListExpenseNote=(data:any)=>request({
  url: ApiURL.Query.ListExpenseNote,
  method: RequestType.POST,
  data:data
 });
 const PreviewExpenseVoucher=(data:any)=>request({
  url: ApiURL.Query.PreviewExpenseVoucher,
  method: RequestType.POST,
  data:data
 });
 const CreateExpenseVoucher=(data:any)=>request({
  url: ApiURL.Query.CreateExpenseVoucher,
  method: RequestType.POST,
  data:data
 });
const ExpenseNoteQuery = {
  ListExpenseNote,
  PreviewExpenseVoucher,
  CreateExpenseVoucher
};

export default ExpenseNoteQuery;